module.exports = "/_next/static/images/hero-94fe80a6adf10c965a5c5f8a8848d522.png";